export default function RichTextInput({ label, id, paragraphText, description, displayOption, disablePlaceholdersReplacement = false }) {
  return (
    <div
      className={`form-element form-element--richtext Form__Element ${displayOption}`}
      id={id}
      data-f-element-nondata=""
      title={description}
      aria-label={description}
    >
      <div className="rich-text" dangerouslySetInnerHTML={{ __html: paragraphText }} />
    </div>
  )
}
